/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */


import { FormGroup } from '@angular/forms';
import { FittingDto, ActionPageEnumDto, ActionTypeEnumDto } from 'api/models';
import { IFittingSizeMapHelper } from './IFittingSizeMapHelper';


export class GenericMapper implements IFittingSizeMapHelper {
  createAddSizeObject(dataArray: any[], userID: string, selectedFitting: FittingDto, statusId: ActionTypeEnumDto) {
    return Object;
  }

  mapToFormGroup(source: any, unitid?: number, actionPage?: ActionPageEnumDto): FormGroup {
    return;
  }

  mapToObject(controls): any {
    return Object();
  }

  getTableHeaders(unitid?: number) {
    return [];
  }
  setDefaultValues(elementForm: FormGroup, baseObject: any, selectedFitting: FittingDto) {
    return;
  }
  setValuesByElement(elementForm: FormGroup, baseObject: any, nominalSizeList?: any, isPartialySaved?: boolean) {
    return;
  }
}
